const API = process.env.REACT_APP_API_ROUTE;

const pad2 = n => String(n).padStart(2, '0');

export const formatFechaTicket = (date) => {
    const d = new Date(date);
    return `${d.getFullYear()}-${pad2(d.getMonth()+1)}-${pad2(d.getDate())} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
};

// ─── Helpers de línea ────────────────────────────────────────────────────────
export const LOGO_URL = '/assets/images/logo_negro.png';

// ─── Impresión por deep link Android ────────────────────────────────────────
export const imprimirTicketDeepLink = ({ folio, fecha, vendedor, sucursal, metodo, cobrado, carrito, total }) => {
    try {
        const lineItems = [];
        carrito.forEach(item => {
            lineItems.push({
                name:  `${item.nombre}`,
                qty:   item.cantidad,
                price: cobrado ? parseFloat((item.precio_total).toFixed(2)) : 0,
            });
            (item.extras || []).forEach(e => {
                lineItems.push({
                    name:  `>> ${e.nombre}`,
                    qty:   item.cantidad,
                    price: cobrado ? parseFloat(e.precio.toFixed(2)) : 0,
                });
            });
        });

        const payload = {
            tipo:          1, 
            folio:         folio || '',
            date:          formatFechaTicket(fecha),
            vendedor:      vendedor || '',
            sucursal:      sucursal || '',
            items:         lineItems,
            total:         cobrado ? parseFloat(total.toFixed(2)) : 0,
            paymentMethod: cobrado && metodo ? metodo : ''
        };

        const json    = JSON.stringify(payload);
        const b64     = btoa(unescape(encodeURIComponent(json)));
        const urlSafe = b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
        window.location.href = `paparollprint://print?data=${urlSafe}`;
    } catch (err) {
        throw new Error(`deeplink_error: ${err.message}`);
    }
};

// ─── Impresión ambulante por deep link Android ──────────────────────────────
export const imprimirTicketAmbulanteDeepLink = ({ folio, fecha, vendedor, responsable, sucursal, carrito, total }) => {
    try {
        const lineItems = [];
        carrito.forEach(item => {
            lineItems.push({
                name:  `${item.nombre}`,
                qty:   item.cantidad,
                price: parseFloat((item.precio_total).toFixed(2)),
            });
            (item.extras || []).forEach(e => {
                lineItems.push({
                    name:  `>> ${e.nombre}`,
                    qty:   item.cantidad,
                    price: parseFloat(e.precio.toFixed(2)),
                });
            });
        });

        const payload = {
            tipo:          2, 
            folio:         folio || '',
            date:          formatFechaTicket(fecha),
            vendedor:      vendedor || '',
            responsable:   responsable || '',
            sucursal:      sucursal || '',
            items:         lineItems,
            total:         parseFloat(total.toFixed(2)),
            paymentMethod: ''
        };

        const json    = JSON.stringify(payload);
        const b64     = btoa(unescape(encodeURIComponent(json)));
        const urlSafe = b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
        window.location.href = `paparollprint://print?data=${urlSafe}`;
    } catch (err) {
        throw new Error(`deeplink_error: ${err.message}`);
    }
};

// ─── Impresión de corte por deep link Android ───────────────────────────────
export const imprimirTicketCorteDeepLink = ({
    folio, fecha, responsable, sucursal, evento,
    efectivoInicial, totalVentas, totalVueltas, totalGastos, totalFinal,
    metodos,
    conosVendidos, conosIniciales, conosTotales, conosFinales,
    tiposConos,
}) => {
    try {
        const payload = {
            tipo:            3,
            folio:           folio || '',
            date:            formatFechaTicket(fecha),
            responsable:     responsable || '',
            sucursal:        sucursal || '',
            evento:          evento || '',
            efectivoInicial: parseFloat((efectivoInicial || 0).toFixed(2)),
            totalVentas:     parseFloat((totalVentas    || 0).toFixed(2)),
            totalVueltas:    parseFloat((totalVueltas   || 0).toFixed(2)),
            totalGastos:     parseFloat((totalGastos    || 0).toFixed(2)),
            totalFinal:      parseFloat((totalFinal     || 0).toFixed(2)),
            metodos:         (metodos || []).map(m => ({
                nombre:    m.nombre,
                neto:      parseFloat((m.neto || 0).toFixed(2)),
                totalReal: m.totalReal != null ? parseFloat((m.totalReal).toFixed(2)) : null,
            })),
            conosVendidos:   conosVendidos  || 0,
            conosIniciales:  conosIniciales || 0,
            conosTotales:    conosTotales   || 0,
            conosFinales:    conosFinales   || 0,
            tiposConos:      (tiposConos || []).map(t => ({ nombre: t.nombre, vendidos: t.vendidos || 0 })),
        };

        const json    = JSON.stringify(payload);
        const b64     = btoa(unescape(encodeURIComponent(json)));
        const urlSafe = b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
        window.location.href = `paparollprint://print?data=${urlSafe}`;
    } catch (err) {
        throw new Error(`deeplink_error: ${err.message}`);
    }
};

// ─── Impresión de liquidación por deep link Android ─────────────────────────
export const imprimirTicketLiquidacionDeepLink = ({ responsable, vendedor, sucursal, fecha, numVentas, totalACobrar, totalPagado, metodos }) => {
    try {
        const payload = {
            tipo:         4,
            date:         formatFechaTicket(fecha),
            responsable:  responsable || '',
            vendedor:     vendedor || '',
            sucursal:     sucursal || '',
            numVentas:    numVentas || 0,
            totalACobrar: parseFloat((totalACobrar || 0).toFixed(2)),
            totalPagado:  parseFloat((totalPagado  || 0).toFixed(2)),
            metodos:      (metodos || []).map(m => ({ nombre: m.nombre, total: parseFloat((m.total || 0).toFixed(2)) })),
        };

        const json    = JSON.stringify(payload);
        const b64     = btoa(unescape(encodeURIComponent(json)));
        const urlSafe = b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
        window.location.href = `paparollprint://print?data=${urlSafe}`;
    } catch (err) {
        throw new Error(`deeplink_error: ${err.message}`);
    }
};

// ─── Impresión de pago ambulante por deep link Android ──────────────────────
export const imprimirTicketPagoDeepLink = ({ vendedor, responsable, fecha, metodo, total }) => {
    try {
        const payload = {
            tipo:        5,
            date:        formatFechaTicket(fecha),
            vendedor:    vendedor    || '',
            responsable: responsable || '',
            metodo:      metodo      || '',
            total:       parseFloat((total || 0).toFixed(2)),
        };

        const json    = JSON.stringify(payload);
        const b64     = btoa(unescape(encodeURIComponent(json)));
        const urlSafe = b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
        window.location.href = `paparollprint://print?data=${urlSafe}`;
    } catch (err) {
        throw new Error(`deeplink_error: ${err.message}`);
    }
};